import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=5385631c&scoped=true&"
import script from "./Checklist.vue?vue&type=script&lang=ts&"
export * from "./Checklist.vue?vue&type=script&lang=ts&"
import style0 from "./Checklist.vue?vue&type=style&index=0&id=5385631c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385631c",
  null
  
)

export default component.exports